<template>
    <v-content class="page_recupera"></v-content>
</template>

<script>
    import {mapActions} from "vuex";
    import AuthService from "@/services/auth.service";

    // Dismissione flusso Call Me Back MPS (07/2026): il recupero quotazione non
    // atterra più sul form "Ti richiamiamo noi" ma sulla pagina del premio.
    export default {
        name: "recupera",
        data: function () {
            return {
                token: this.$route.params.token,
            };
        },
        methods: {
            ...mapActions({
                'actionQuotationParams': 'params/actionQuotationParams'
            }),
        },
        mounted() {
            if (!this.token) {
                this.$router.replace({name: 'home_mps'});
                return;
            }
            let app_retrieve_url = process.env.VUE_APP_RETRIEVE + '/' + this.token;

            // L'app monta prima che il bootstrap OAuth di main.js abbia ottenuto il
            // token: sulla visita diretta da link email serve autenticarsi qui.
            AuthService.authentication()
                .then(() => axios.get(app_retrieve_url, {timeout: 10000}))
                .then(resp => {
                    this.actionQuotationParams(resp.data.data);
                    this.$router.replace({name: 'premio_mps'});
                })
                .catch(err => {
                    console.log(err);
                    this.$router.replace({name: 'home_mps'});
                });
        },
    };
</script>
